module.exports = __webpack_public_path__ + "static/media/cross-icon.f9992496.svg";